export enum ContainerName {
  Incoming = 'incoming',
  Files = 'files',
  Pathology = 'pathology',
}
